<template>
  <div class="login py-5">
    <div id="firebaseui-auth-container" />

    <div v-if="logged" class="alert alert-success col-6 offset-3 my-5">
      Du bist eingeloggt.
    </div>
  </div>
</template>

<script>
  import { firebaseUiConfig } from '../database.js'

  export default {
    name: 'login',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    computed: {
      logged() {
        console.log('logged', this.$store.state.user)

        if(!this.$store.state.user.isAnonymous){
          this.$router.replace('/')
        }

        return false
      }
    },
    mounted() {
     this.$store.state.ui.start("#firebaseui-auth-container", firebaseUiConfig);
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?5a057f18